type TEquivalency = {
  title: string;
  code: string;
  subject: string;
  number: string;
  credits: number;
};

type TCourse = {
  transferred: TTransferred[];
  equivalent: TEquivalency[];
};

type TTransferred = {
  name: string;
  code: string;
  subject: string;
  number: string;
  term_type: string | null;
  term_year: number | null;
  credits: number | null;
  grade: string | null;
};

type TExam = {
  exam_type: string;
  exams: TExamDetail[];
};

type TExamDetail = {
  transferred: TransferredExam[];
  equivalent: TEquivalency[];
};

type TransferredExam = {
  name: string;
  score: number;
};

type TCollege = {
  name: string;
  city: string;
  state: string;
  code: string;
  courses: TCourse[];
  title: string;
};
export class EquivalentCourse {
  id: number = 0;
  exams: TExam[] = [];
  colleges: TCollege[] = [];

  constructor(equivalent_course: EquivalentCourse) {
    _.merge(this, equivalent_course);
    
    _.forEach(this.colleges, (college) => {
      let titleParts: string[] = [];
      if (!_.isEmpty(college.city)) {
        titleParts.push(college.city);
      }
      if (!_.isEmpty(college.state)) {
        titleParts.push(college.state);
      }
      college.title = titleParts.join(', ') || '';
    });
  }

  static build(equivalent_course: any): EquivalentCourse {
    return new EquivalentCourse(equivalent_course);
  }
}

angular
  .module('capability-ng-transfer')
  .factory( 'ngEquivalentCourseBuilder', (): typeof EquivalentCourse => {
      return EquivalentCourse;
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/equivalent_courses_builder.ts